module.exports = __webpack_public_path__ + "static/img/3.8d06952.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/1/zh/3.png
// module id = F1LC
// module chunks = 0